// material
import { Stack, Container, Typography } from '@mui/material';

// components
import Page from '../components/Page';
import FormUser from '../components/profile/form/user';
import FormPassword from '../components/profile/form/password';

export default function User() {
  return (
    <Page title="Profile" path="/profile">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Account
          </Typography>
        </Stack>
        <FormUser />
        <FormPassword />
      </Container>
    </Page>
  );
}
